import { type ReactNode } from "react";
import InfoModal from "./InfoModal";

export type ViewLayoutProps = {
  children: ReactNode;
  description?: string;
  /**
   * Heading for the info dialog. Defaults to the page title, but a dialog headed
   * the same as the page it opens on tells the reader nothing — prefer something
   * like "Sådan læser du dine afgørelser".
   */
  infoTitle?: string;
  /** Screen-reader-only summary of the dialog. Omitted when not given. */
  infoDescription?: string;
  infoText?: ReactNode;
  title: string;
  className?: string;
};

const ViewLayout = ({
  children,
  description,
  infoTitle,
  infoDescription,
  infoText,
  title,
  className,
}: ViewLayoutProps) => {
  return (
    <div className={className}>
      <div className={"row"}>
        <div className="">
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <h1>{title}</h1>
              {infoText != null && (
                <InfoModal
                  title={infoTitle ?? title}
                  description={infoDescription}
                  ariaLabel={`Læs mere om ${title}`}
                >
                  {infoText}
                </InfoModal>
              )}
            </div>
            {description != null && description !== "" && (
              <div className="text-muted fs-6 col-12 col-lg-10">
                {description}
              </div>
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default ViewLayout;
